import { ERROR_CODE_AXIOS } from "./config";
import error from "./error";
import { store } from '../store';
import { GLOBAL_TYPE, USER_TYPE } from "../store/constants";

export default {
    setupInterceptors: (axios, isFormData = false, isToken = false) => {
        axios.interceptors.request.use((config) => {
            if (isFormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            }
            if (isToken) {
                const user = store.getState().user;
                config.headers['Authorization'] = 'Bearer ' + user.userAccessToken;
            }
            return config;
        },
            (error) => {
                return Promise.reject(error);
            }
        );
        axios.interceptors.response.use(
            response => successHandler(response),
            error => errorHandler(error)
        );
        const errorHandler = (error) => {
            return Promise.reject({ ...error })
        };
        const successHandler = (response) => {
            const { code, desc } = response.data;
            if (code != ERROR_CODE_AXIOS.SUCCESS) {
                if (code == ERROR_CODE_AXIOS.TOKEN_EXPIRED_1 || code == ERROR_CODE_AXIOS.TOKEN_EXPIRED_2 || code == ERROR_CODE_AXIOS.NOT_AUTHORIZED) {
                    store.dispatch({
                        type: USER_TYPE.LOGOUT,
                        payload: {}
                    })
                    store.dispatch({
                        type: GLOBAL_TYPE.LOGIN_EXPIRED
                    })
                }
                return Promise.reject({
                    message: desc ? desc : error.getMessageError(code),
                    code: code
                })
            }
            return response.data;
        };
    }
};
